module.exports = __webpack_public_path__ + "static/media/IMG-3.511ff56b.jpg";